import React, { useState } from 'react';
import styled from 'styled-components';
import { useAdminSupport } from '../../share/hook/useAdminSupport';
import { shrinkString } from '../../../shared/util/shrinkString';
import { SupportData } from '../../../shared/dto/EntityRepository';
import AdminBlockWithVisible from '../../share/component/AdminBlockWithVisible';
import { formatTimeHM } from '../../../shared/util/timeInvertor/formatTimeHM';
import { getSupportTypeLabel } from '../../../shared/enum/EnumRepository';
import { useLanguageStore } from '../../../shared/store/languageStore';

interface SupportInfoProps {
  data: SupportData;
  isSelected: boolean;
  handleClick: () => void;
}

const SupportInfo: React.FC<SupportInfoProps> = ({
  data,
  isSelected,
  handleClick
}) => {
  const { activeSupport } = useAdminSupport();
  const { language } = useLanguageStore();
  const [hovered, setHovered] = useState(false);

  return (
    <SupportInfoComp
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <ContentWrapper>
        <TitleBlock $isHover={hovered} $isActive={isSelected}>
          <TitleText>{shrinkString(data.title, 30)}</TitleText>
        </TitleBlock>
        <AdminBlockWithVisible
          width={"1.5"}
          value={getSupportTypeLabel(data.type, language)}
          isHover={hovered}
          isActive={isSelected} />
        <AdminBlockWithVisible
          width={"1.5"}
          value={data.aui}
          isHover={hovered}
          isActive={isSelected} />
        <AdminBlockWithVisible
          width={"1.5"}
          value={formatTimeHM(data.createdAt)}
          isHover={hovered}
          isActive={isSelected} />
        <AdminBlockWithVisible
          width={"1.5"}
          value={data.status}
          isHover={hovered}
          isActive={isSelected} />
        {activeSupport && <SpaceBlock />}
      </ContentWrapper>
    </SupportInfoComp>
  );
};


const SupportInfoComp = styled.article`
  position: relative;
  display: flex;
  width: 100%;
  height: 40px;
  min-height: 40px;
  cursor: pointer;
  
  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Body_04};
`;

const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

const TitleBlock = styled.div<{ $isHover: boolean; $isActive: boolean }>`
  flex: 2.5;
  min-width: 0;
  display: flex;
  align-items: center;
  padding-left: 10px;
  text-decoration: ${({ $isActive }) => ($isActive ? 'underline' : 'none')};
  background-color: ${({ theme, $isHover, $isActive }) =>
    $isActive ? theme.colors.color_Gray_06 : $isHover ? theme.colors.color_Gray_07 : 'transparent'};
  border-bottom: 0.5px solid ${({ theme }) => theme.colors.color_Gray_04};
  cursor: pointer;
`;

const TitleText = styled.div`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const SpaceBlock = styled.div`
  flex: 0.15;
  display: flex;
  align-items: center;
  justify-content: center;
`;


export default SupportInfo;
